// extracted by mini-css-extract-plugin
module.exports = {"LongText":"LongTextContainer_LongText__/wU/J"};